<div aria-labelledby="dropdownMenuLink" class="dropdown-menu">
  <button class="d-flex dropdown-item" type="button">
    Fermer
    <mat-icon aria-hidden="false" class="ml-auto">close</mat-icon>
  </button>
  <div *ngFor="let action of colActions"
  [hidden]="shouldHideAction(action, element, canBeLier, reliables)"
       aria-labelledby="{{action.icon}}" class="w-100 text-nowrap">
    <button class="dropdown-item" type="button"
            (click)="getEvent(action,element,'A_1',liables,reliables)">{{ action.description }}
    </button>
  </div>
</div>
